<template>
  <div v-loading="showFlag">
    <t-card>
      <t-form
        ref="userCustomersFormData"
        domain="userManage"
        label-position="right"
        label-width="100px"
        class="userCustomersForm"
      >
        <t-row>
          <t-col :span="24">
            <template>
              <t-transfer
                v-model="customersSelectList"
                :props="{
                  key: 'cusCode',
                  label: 'cusName',
                }"
                :data="this.customersList"
                :titles="[
                  $t('resource.userManager.customers'),
                  $t('resource.userManager.userCustomers'),
                ]"
                filterable
                class="centered-transfer"
              >
              </t-transfer>
            </template>
          </t-col>
        </t-row>
        <t-row>
          <t-col :span="24" style="padding-top: 10px">
            <t-form-item class="float-right">
              <!-- 変更 -->
              <t-button
                round
                type="warning"
                class="dialogButton_confirm_120_40"
                @click="Confirm"
              >
                <i class="el-icon-check"></i
                >{{ $t("resource.button.change") }}</t-button
              >
            </t-form-item>
          </t-col>
        </t-row>
      </t-form>
    </t-card>
  </div>
</template>

<script>
import { t } from "@/locales";
import {
  SearchUserCustomer,
  UpdateUserCustomer,
} from "@/services/userCustomerInfo";
import { cmpDetailData } from "@/utils/comFunction";
import { Message, Modal } from "@tellus/component";

export default {
  props: {
    userId: {
      type: String,
    },
  },

  data() {
    return {
      //得意先リスト
      customersList: [],
      //担当得意先情報リスト
      userCustomersList: [],
      //選択した担当得意先情報リスト
      userCustomersOutList: [],
      //担当(選択)得意先データの作成
      customersSelectList: [],
      //待ち表示フラグ
      showFlag: false,

      // 読み込み回数
      numLoads: 1,

      // 比較用基本情報
      cmpBasicResult: {},
    };
  },

  computed: {},

  mounted() {
    this.Init();
  },

  computed: {},

  methods: {
    // 初期化
    Init() {
      //console.log("this.userId---" + JSON.stringify(this.userId));

      this.showFlag = true;
      this.SearchUserCustomer();
    },

    // 検索
    SearchUserCustomer() {
      SearchUserCustomer({
        selectUserId: this.userId,
      })
        .then((res) => {
          //得意先リスト
          this.customersList = res.customersList;
          //担当得意先情報リスト
          this.userCustomersList = res.userCustomersList;
          this.showFlag = false;

          // ADD 2025/03/10 ZLL 課題_運送製品選択画面_検索条件と一覧列の追加 start↓
          //「担当(選択)得意先データ検索前に未クリア、複数回保存した後、データが重複し、保存に失敗した」問題の対応
          this.customersSelectList = [];
          // ADD 2025/03/10 ZLL 課題_運送製品選択画面_検索条件と一覧列の追加 end↑
          //担当(選択)得意先データの作成
          for (let i = 0; i < this.userCustomersList.length; i++) {
            this.customersSelectList.push(this.userCustomersList[i].ucCusCode);
          }

          // 読み込み回数 = 1
          if (!this.isAddFlg && this.numLoads == 1) {
            // 比較用基本情報
            this.cmpBasicResult = JSON.parse(
              JSON.stringify(this.customersSelectList.sort())
            );

            // 読み込み回数 + 1
            this.numLoads = this.numLoads + 1;
          }
        })
        .catch((err) => {
          this.showFlag = false;
          Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
        });
    },

    // 編集
    Confirm() {
      this.showFlag = true;
      //担当得意先のクリア
      this.userCustomersOutList.length = 0;

      //選択した得意先の繰り返し
      for (let i = 0; i < this.customersSelectList.length; i++) {
        //選択した担当得意先
        this.userCustomersOutList.push({
          //ユーザーID
          ucUserId: this.userId,
          //得意先コード
          ucCusCode: this.customersSelectList[i],
          //管理区分
          ucManagerKbn: "1",
          //更新者
          ucUpdateUser: localStorage.getItem("useId"),
        });
      }

      UpdateUserCustomer({
        selectUserId: this.userId,
        userCustomersList: this.userCustomersOutList,
      })
        .then((res) => {
          // console.log("showSuccess");
          this.showFlag = false;
          this.numLoads = 1;
          Message.showSuccess(t("message.COMMON_MESSAGE.UPDATE_SUCCESS"));

          this.SearchUserCustomer();
        })
        .catch((err) => {
          this.showFlag = false;
          // console.log("showError");
          Message.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
        });
    },

    // ダイアログを閉じる
    onCancel() {
      if (
        !this.isAddFlg &&
        !cmpDetailData(this.cmpBasicResult, this.customersSelectList.sort())
      ) {
        return new Promise((resolve, reject) => {
          Modal.showWarning(
            "",
            t("message.COMMON_MESSAGE.DATA_ALREADY_CHANGED_CLOSE"),
            {
              $type: "prompt",
              confirmButtonText: t("resource.button.sure"),
              cancelButtonText: t("resource.button.cancel"),
              showCancelButton: true,
            }
          )
            .then(() => {
              // 用户点击确认
              resolve(true);
            })
            .catch((error) => {
              // 用户点击取消或关闭对话框
              resolve(false);
            });
        });
      } else {
        return true;
      }
    },
  },
};
</script>
<style>
/* UPD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 start↓ */
/* .el-transfer-panel {  */
/* width: 230px; */
/* } */

.el-transfer-panel__body {
  height: 380px;
}

/*.el-transfer-panel__list {
  height: 350px !important;
} */

.centered-transfer {
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  margin: 0 auto;
  width: 90%;
}

.centered-transfer .el-transfer-panel {
  width: 38% !important;
  min-width: 230px;
}

.centered-transfer .el-transfer {
  display: flex !important;
  justify-content: space-between !important;
  width: 100% !important;
}

.centered-transfer .el-transfer-panel__list {
  width: 100% !important;
  height: 350px !important;
}
/* UPD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 end↑ */
</style>

